module.exports = "/static/assets/2f9cda00a530ac237fc24063067377c3.svg";